'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

module.exports = function (_React$Component) {
    _inherits(_class2, _React$Component);

    function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function () {
            if (_this.props.handleClick) {
                _this.props.handleClick();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class2.prototype.render = function render() {
        var size = this.props.size ? this.props.size : 'large';
        var customIconClass = this.props.customIconClass ? this.props.customIconClass : '';
        var customClass = this.props.customClass ? this.props.customClass : '';
        var icon = this.props.icon ? React.createElement('span', { className: "glyphicon icon-button-glyph " + customIconClass + " glyphicon-" + this.props.icon, 'aria-hidden': 'true' }) : React.createElement('img', { src: this.props.image });
        return React.createElement(
            'div',
            { onClick: this.handleClick, className: customClass + " icon-button icon-button-" + size, id: this.props.id },
            icon,
            React.createElement(
                'span',
                { className: 'icon-text' },
                this.props.text
            )
        );
    };

    return _class2;
}(React.Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/iconButton.js
// module id = 833
// module chunks = 0